import ListSalesOrders from "../../../../components/@documents/sales_orders/ListSalesOrders";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesOrdersPage() {

    return (
        <ListSalesOrders 
            routeType={routeTypes.retail}
        />
    )
}